export const formatFullName = (
  firstName: string,
  lastName: string | null | undefined,
): string => [firstName, lastName].filter(Boolean).join(" ");

export const capitalize = (str: string): string => {
  if (!str || typeof str !== "string") return "";
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const LATIN_WORD_PATTERN =
  /\p{Script=Latin}[\p{Script=Latin}\p{Script=Inherited}'’]*/gu;
const SENTENCE_START_PATTERN = /(^\s*|[.!?]\s+)(\p{Script=Latin})/gu;

export const toTitleCase = (text: string | null | undefined): string => {
  if (!text) return "";
  return text.replace(
    LATIN_WORD_PATTERN,
    (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
  );
};

export const toSentenceCase = (text: string | null | undefined): string => {
  if (!text) return "";
  const lowercased = text.replace(LATIN_WORD_PATTERN, (word) =>
    word.toLowerCase(),
  );
  return lowercased.replace(
    SENTENCE_START_PATTERN,
    (_fullMatch, sentenceBoundary: string, firstLetter: string) =>
      `${sentenceBoundary}${firstLetter.toUpperCase()}`,
  );
};

export const decode = (id: string): string => {
  const parts = id.split("|");
  return parts.length > 1 ? parts[1] : id;
};

export const resolveRoomStayId = (roomStayId: string): string =>
  decode(roomStayId.split(":::").at(-1) ?? roomStayId);

export const pluralize = (
  count: number,
  singular: string,
  plural?: string,
): string => {
  if (count === 1) return singular;
  return plural ?? `${singular}s`;
};

export const pluralizeWithCount = (
  count: number,
  singular: string,
  plural?: string,
): string => {
  return `${count} ${pluralize(count, singular, plural)}`;
};
